import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Button from '@material-ui/core/Button';
import { addQueryWithReplace, removeQuery } from 'Helpers/Query';
import Typography from '@material-ui/core/Typography';
import { createNewGoal } from 'Consts/Queries';
import Icon from '@material-ui/core/Icon';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';

const styles = theme => ({
  root: {
    display: 'flex',
    backgroundColor: theme.palette.common.white,
    width: '100%',
    maxWidth: theme.dimensions.xxl,
    height: '100%',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: theme.spacing(4, 1),
  },
  goalTypeButton: {
    display: 'flex',
    width: '152px',
    height: '152px',
    margin: theme.spacing(1),
    backgroundColor: theme.palette.common.white,
  },
  goalTypeButtonLabel: {
    flexDirection: 'column',
  },
  goalTypeButtonText: {
    marginTop: theme.spacing(2),
    color: theme.palette.facet.darkGray,
  },
  goalTypeIcon: {
    width: '100%',
    height: '100%',
  },
  [theme.breakpoints.down('md')]: {
    root: {
      justifyContent: 'center',
    },
  },
  [theme.breakpoints.down('sm')]: {
    root: {
      height: 'unset',
    },
  },
});

const GoalTypeSelector = ({
  className,
  classes,
  goalCollection,
}) => {
  const {
    rootNodeProps,
    logEvent,
  } = useEventTrackingLogEvent({ nodeName: 'Goal Type Selector' });
  const goalIcons = goalCollection.meta().field('icon').options().map();
  const goalLabels = goalCollection.meta().field('type').options().list();
  const goalLabelsMap = goalCollection.meta().field('type').options().map();


  const handleSetGoalTypeParam = (goalTypeId) => {
    removeQuery(createNewGoal);
    addQueryWithReplace({ goalType: goalTypeId });
    logEvent('Client Goals Page: Clicked Goal Type Button', {
      goalTypeId,
      goalTypeName: goalLabelsMap[goalTypeId].attr('prompt'),
    });
  };

  return (
    <div
      {...rootNodeProps}
      className={classNames(classes.root, className)}
    >
      {goalLabels.map(opt => (
        <Button
          variant="contained"
          onClick={() => handleSetGoalTypeParam(opt.attr('id'))}
          className={classes.goalTypeButton}
          classes={{
            label: classes.goalTypeButtonLabel,
          }}
        >
          <Icon className={classes.goalTypeIcon}>
            <img src={goalIcons[opt.attr('id')].attr('prompt')} />
          </Icon>
          <Typography variant="h6" className={classes.goalTypeButtonText}>
            {opt.attr('prompt')}
          </Typography>
        </Button>
      ))}
    </div>
  );
};

GoalTypeSelector.defaultProps = {
  className: '',
};

GoalTypeSelector.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  goalCollection: PropTypes.object.isRequired,
};

export default withStyles(styles)(GoalTypeSelector);
